export var promoTextVerticalPaddingSpace = 1;
export var promoTextTypography = "nano2_u";
export var mainBackground = "backgroundLight";
export var darkModeBackground = "backgroundDark";
export var promoBoxColor = "primary";
export var footerBackground = "background";